$(document).ready(function() {
  $(document).on("click", "a.noshadowToggle", function() {
    if ($("nav.mobile").hasClass("noshadow")) {
      $("nav.mobile").removeClass("noshadow");
    } else {
      $("nav.mobile").addClass("noshadow");
    }
  });
});
